/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "models": {
            "nested": {
              "SalesTaxEntry": {
                "fields": {
                  "name": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "percentage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "enabled": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.models?.nested?.SalesTaxEntry) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a sales tax entry for a merchant
 * --
 *
 * SOURCE SalesTaxEntry @ squareup/sfs/models/sales_tax_entry.proto at 8:1
 */
export const SalesTaxEntry = $root.lookupType('squareup.sfs.models.SalesTaxEntry');
fixType(SalesTaxEntry);
Builder.createAndAttachToType(SalesTaxEntry);